import ImportTaskTable from "@/app/app-shared/import-data/table";

export default function ImportTaskListingPage() {
  return (
    <div className="mt-4">
      <ImportTaskTable />
    </div>
  );
}
